import { render, staticRenderFns } from "./Commission.vue?vue&type=template&id=3e589694&scoped=true&"
import script from "./Commission.vue?vue&type=script&lang=js&"
export * from "./Commission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e589694",
  null
  
)

export default component.exports